import React from 'react';
import { Body1, H4 } from '@xo-union/tk-ui-typography';
import { DisplayButton } from '@xo-union/tk-ui-links';
import styles from './rsvpEmptyState.scss';

const RSVPEmptyState: React.FC = () => {
  const goToRSVPWorkFlow = (): void => {
    const workflowPath = '/gs/dashboard/rsvp-workflow';
    if (process.env.NODE_ENV === 'development') {
      alert(`Button was clicked. Navigating to ${workflowPath}`);
    } else {
      window.location.href = workflowPath;
    }
  };

  return (
    <div className={`${styles.cardSection} ${styles.sectionFlex}`}>
      <div className={styles.textGroup}>
        <H4 className={styles.discoverText} as="h2">
          Online RSVP
        </H4>
        <Body1 className={styles.blankWorkflowBody}>
          <div className={styles.numberContainer}>
            <span className={styles.numberIcon}>1</span>
            <span>Customize your online RSVP form</span>
          </div>
          <div className={styles.numberContainer}>
            <span className={styles.numberIcon}>2</span>
            <span>Share your Website's link with your guests</span>
          </div>
          <div className={styles.numberContainer}>
            <span className={styles.numberIcon}>3</span>
            <span>Instantly track guests' responses right here on The Knot!</span>
          </div>
        </Body1>
        <div className={styles.linkContainer}>
          <DisplayButton onClick={goToRSVPWorkFlow} className={styles.pointer} color="primary">
            Start Drafting your Form
          </DisplayButton>
        </div>
      </div>
    </div>
  );
};

export default RSVPEmptyState;
